export default "{\n    \"viewOptions\": {\n        \"month\": \"Mois\",\n        \"week\": \"Semaine\",\n        \"day\": \"Jour\"\n    }\n}\n"